import { render, staticRenderFns } from "./AdmissionNoteDocument.vue?vue&type=template&id=36366c64&scoped=true"
import script from "./AdmissionNoteDocument.vue?vue&type=script&lang=js"
export * from "./AdmissionNoteDocument.vue?vue&type=script&lang=js"
import style0 from "./AdmissionNoteDocument.vue?vue&type=style&index=0&id=36366c64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36366c64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36366c64')) {
      api.createRecord('36366c64', component.options)
    } else {
      api.reload('36366c64', component.options)
    }
    module.hot.accept("./AdmissionNoteDocument.vue?vue&type=template&id=36366c64&scoped=true", function () {
      api.rerender('36366c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/AdmissionNoteDocument.vue"
export default component.exports